'use client'

import { useCheckUserMutation, useSignInTgMutation } from '@/shared/api-rtk'
import { useGetCountProductsQuery } from '@/shared/api-rtk/api-list/cartApi'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import { useEffect, useLayoutEffect } from 'react'
import { redirect } from 'next/navigation'

export const TelegramAuthEndpoint = () => {
    const [signInTg] = useSignInTgMutation()

    const { userAuth: isAuth, setUser, userInfo } = useGetIsAuthUser()
    const [checkAuth] = useCheckUserMutation()
    const { refetch: refetchCountCart } = useGetCountProductsQuery()

    //check auth
    const navigate = (path) => redirect(path)
    useEffect(() => {
        if (isAuth) {
            navigate('/my-account', { replace: true })
        }
    }, [isAuth])

    useLayoutEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const id = urlParams.get('id')
        const first_name = urlParams.get('first_name')
        const photo_url = urlParams.get('photo_url')
        const auth_date = urlParams.get('auth_date')
        const hash = urlParams.get('hash')
        //console.log(13)
        if (id) {
            signInTg({ id, first_name, photo_url, auth_date, hash })
                .unwrap()
                .then((res) => {
                    //console.log(1313)
                    if (res.error) {
                        TOAST_ERROR(res.error)
                        return
                    }
                    if (res.result === 'success') {
                        //console.log(131313)
                        TOAST_SUCCESS('Вы успешно вошли!')
                        //Назначаем пользователя при успешной регистрации в стейт
                        setUser(res.data)
                        refetchCountCart()
                    }
                })
                .catch((err) => {
                    //console.log(13131313)
                    TOAST_ERROR('Ошибка аунтефикации, попробуйте позже')
                })
        }
    }, [])

    return <div>Telegram auth</div>
}
